import { useSubmissionQuery } from '~/public/lib/PublicQueries';
import { useSetCurrency } from '~/lib/CurrencyHelpers';
import ThemedForm from '~/components/forms/ThemedForm';
import FormBackgroundContainer from '~/components/forms/FormBackgroundContainer';
import PageContainer from '~/public/components/PageContainer';
import Loading from '~/components/Loading';
import FormThankYou from '~/public/components/FormThankYou';
import ErrorMessage from '~/components/ErrorMessage';
import { useSetLocale } from '~/lib/useSetLocale.js';

const ThemedConfirmationContainer = ({ token, children }) => {
    const { data, isLoading } = useSubmissionQuery(token);

    useSetLocale(data?.context);

    return (
        <ThemedForm
            styles={data?.form?.settings?.styles}
            objectType="form"
            objectId={data?.form?.id}
            // This page is the thank you step, reached on its own rather than
            //  inside the form, so it names the state itself
            state="thank-you"
            // Sanitized server side and sent with the submission. Without it
            //  the confirmation is the one page a business's own styling never
            //  reached — the form it was submitted from has it throughout
            customCss={data?.customCss}
        >
            <FormBackgroundContainer styles={data?.form?.settings?.styles}>
                <PageContainer form={data?.form}>
                    {isLoading && <Loading className="text-center" />}
                    {data && !data.error && children(data)}
                    {!!data?.error && (
                        <ErrorMessage className="text-center">
                            <div>{data?.error}</div>
                            <div>Please check the link and try again.</div>
                        </ErrorMessage>
                    )}
                </PageContainer>
            </FormBackgroundContainer>
        </ThemedForm>
    );
};

export default ThemedConfirmationContainer;
